export default __webpack_public_path__ + "static/Inter-SemiBold-3be6b9e3b22c24eaada78645bd238f38.woff2";